var _title, _path, _path2, _path3, _path4, _path5, _path6, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "print")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.24,30H31.5v-2.5h2.74A1.76,1.76,0,0,0,36,25.71V14.09a1.76,1.76,0,0,0-1.76-1.76H5.76A1.76,1.76,0,0,0,4,14.09V25.71a1.76,1.76,0,0,0,1.76,1.76H8.5V30H5.76A4.26,4.26,0,0,1,1.5,25.71V14.09A4.26,4.26,0,0,1,5.76,9.83H34.24a4.26,4.26,0,0,1,4.26,4.26V25.71A4.26,4.26,0,0,1,34.24,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.24,39.13H10.76a2.94,2.94,0,0,1-2.94-2.94V20H32.18V36.19A2.94,2.94,0,0,1,29.24,39.13ZM10.32,22.47V36.19a.44.44,0,0,0,.44.44H29.24a.44.44,0,0,0,.44-.44V22.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.18,12.33H7.82V3.46A2.59,2.59,0,0,1,10.41.87H29.59a2.59,2.59,0,0,1,2.59,2.59ZM10.32,9.83H29.68V3.46a.09.09,0,0,0-.09-.09H10.41a.09.09,0,0,0-.09.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.41,27.53H12.59a1.25,1.25,0,0,1,0-2.5H27.41a1.25,1.25,0,0,1,0,2.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46,22.47H6.54a1.25,1.25,0,1,1,0-2.5H33.46a1.25,1.25,0,0,1,0,2.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.41,32H12.59a1.25,1.25,0,0,1,0-2.5H27.41a1.25,1.25,0,0,1,0,2.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.35,
    cy: 14.88,
    r: 1.07
  })));
}

export default SvgPrint;